import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var ExternalLinkIcon = function ExternalLinkIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsxs("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "ExternalLinkIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: [jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M3.41 3.074h2.516a.778.778 0 0 1 0 1.556H3.437c-.303 0-.484 0-.618.011a.7.7 0 0 0-.125.019.26.26 0 0 0-.109.108.7.7 0 0 0-.018.125c-.01.134-.011.315-.011.618v7.052c0 .303 0 .484.011.618a.7.7 0 0 0 .018.125.26.26 0 0 0 .109.109c.01.002.044.011.125.018.134.01.315.011.618.011h7.052c.303 0 .484 0 .618-.011a.7.7 0 0 0 .125-.018.26.26 0 0 0 .109-.109.7.7 0 0 0 .018-.125 9 9 0 0 0 .011-.618v-2.489a.778.778 0 1 1 1.556 0v2.516c0 .267 0 .512-.017.717-.018.221-.06.463-.18.702-.175.342-.452.62-.794.793a1.8 1.8 0 0 1-.702.181c-.205.017-.45.017-.717.017H3.41c-.267 0-.512 0-.717-.017a1.8 1.8 0 0 1-.702-.18 1.8 1.8 0 0 1-.793-.794 1.8 1.8 0 0 1-.181-.702C1 13.102 1 12.857 1 12.59V5.484c0-.267 0-.512.017-.717a1.8 1.8 0 0 1 .18-.702c.175-.342.452-.62.794-.793a1.8 1.8 0 0 1 .702-.181c.205-.017.45-.017.717-.017m7.93 10.235v-.002zm-.105.105h-.002zm-8.544 0h.002zm-.105-.107v.002zm0-8.542v.002zm.107-.105H2.69z",
      clipRule: "evenodd"
    }), jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M9.296 1.778c0-.43.349-.778.778-.778h4.148c.43 0 .778.348.778.778v4.148a.778.778 0 1 1-1.556 0v-2.27L7.513 9.587a.778.778 0 0 1-1.1-1.1l5.932-5.931h-2.27a.78.78 0 0 1-.779-.778",
      clipRule: "evenodd"
    })]
  }));
};

export { ExternalLinkIcon };
